<template>
  <div class="advertisement">
    <div class="advertisement-header">
      <div class="advertisement-header-text">
        <h3>系统平台搭建审核</h3>
   
      </div>
    </div>
    <records type="4"></records>
  </div>
</template>

<script>
import records from "../components/records"
export default {
  components:{
    records
  },
  data(){
    return{
    }
  },
  methods:{
 
  }
}
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}

.advertisement{
  width: 100%;
  background: #0c0c0c;

  &-header{
    width: 100%;
    min-height: 460px;
    padding: 0 100px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    overflow: hidden;
    // background:
    //   linear-gradient(270deg, rgba(10, 10, 10, 0.92) 0%, rgba(10, 10, 10, 0.74) 44%, rgba(10, 10, 10, 0.32) 100%),
    //   url("../assets/background4.png") no-repeat center center;
    background-size: cover;

    &::after{
      content: "";
      position: absolute;
      left: 100px;
      right: 100px;
      bottom: 78px;
      height: 1px;
      background: linear-gradient(270deg, rgba(249, 201, 46, 0.95), rgba(249, 201, 46, 0.08));
    }

    &-text{
      position: relative;
      z-index: 1;
      max-width: 720px;
      padding-right: 28px;
      border-right: 4px solid #f9c92e;
      text-align: right;

      h3{
        .fontdemo(48px, 'PingFangSC,PingFang SC', 600, #ffffff);
        margin: 0;
        line-height: 1.2;
        letter-spacing: 1px;
        text-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);
      }
    }
  }
}
</style>
